// extracted by mini-css-extract-plugin
export default {"title":"ValuesTable_title__LggVd"};